import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import StudentDetailsItems from "./items";
import { checkNestedProperties } from "../../utils";
import apiCall from "../../api";
import { setAnswersLessons } from "../../../actions";

const  StudentDetailsLessons = ({studentId, intervention, setUnseenLesson, setUnseenLessonMain}) => {

  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [answers, setAnswers] = useState([]);

  const typesWeNeed = ["matrix", "question_open", "question_checkboxes", "question_radio", "select", "slider", "custom", "feedback_questionnaire"];

  useEffect(() => {

    setLoading(true);
    setUnseenLesson(false);
    setUnseenLessonMain(studentId, false);

    if (checkNestedProperties(intervention, 'settings', 'selfhelp', 'lessons')) 
    {
        let lessons = intervention.settings.selfhelp.lessons;
        //aantekenen welke lessen invul oefeninen bevatten
        lessons.map((item, index) => {
            lessons[index]["hasFillinParts"] = true; //op true zetten, ivm show context...
            lessons[index]["optional"] = false;
            lessons[index].settings.parts.map(part => {

                if (typesWeNeed.indexOf(part.type) > -1)
                {
                    lessons[index]["hasFillinParts"] = true;
                }
            })
        })

        let optionalLessons = intervention.settings.selfhelp.optionalLessons;
        //aantekenen welke lessen invul oefeninen bevatten
        optionalLessons.map((item, index) => {
            optionalLessons[index]["hasFillinParts"] = true; //op true zetten, ivm show context...
            optionalLessons[index]["optional"] = true;
            optionalLessons[index].settings.parts.map(part => {

                if (typesWeNeed.indexOf(part.type) > -1)
                {
                    optionalLessons[index]["hasFillinParts"] = true;
                }
            })
        })

        setItems(lessons.concat(optionalLessons));

        apiCall({
            action: "get_lesson_answers",
            token: auth.token,
            data: {
                id: lessons[0].id,
                student_id: studentId,
            }
            }).then(resp => {
                setAnswers(resp.allAnswers);
                //also set in redux store tbv feedback component 
                dispatch(
                            setAnswersLessons(
                                intervention.id,
                              resp.allAnswers
                              )
                          )

                setLoading(false);
            })

    }
  }, [studentId])

  return(
    loading ? <i className="fas fa-spinner fa-spin"></i> :
    <StudentDetailsItems type="lesson" items={items} answers={answers} studentId={studentId} interventionID={intervention.intervention_id} />
  )
}

export default StudentDetailsLessons
